import { css } from 'lit';

export default css`
  :host {
    align-items: center;
    background: var(--sl-color-background-neutral-subtle);
    box-sizing: border-box;
    display: flex;
    padding: calc((var(--sl-size-150) - var(--sl-size-075)) / 2) var(--sl-size-050);
    user-select: none;
  }

  :host([vertical]) {
    padding: var(--sl-size-050) calc((var(--sl-size-150) - var(--sl-size-075)) / 2);
  }

  [part='track'] {
    display: flex;
    flex: 1;
  }

  [part='thumb'] {
    --_bg-opacity: var(--sl-opacity-interactive-plain-idle);

    background: color-mix(
      in srgb,
      var(--sl-color-background-neutral-interactive-plain),
      var(--sl-color-background-neutral-interactive-bold) calc(100% * var(--_bg-opacity))
    );
    block-size: var(--sl-size-075);
    border-radius: var(--sl-size-borderRadius-md);
    inline-size: var(--sl-thumb-size, 100px);
    translate: var(--sl-thumb-translate, 0) 0;
  }

  [part='thumb']:hover {
    --_bg-opacity: var(--sl-opacity-interactive-plain-hover);
  }

  [part='thumb']:active {
    --_bg-opacity: var(--sl-opacity-interactive-plain-active);
  }
`;
